export default "__VITE_ASSET__DxUYD2$r__"